import Image from "next/future/image";

import Link from "next/link";
import React from "react";
import call from "../../assets/images/svg/call.svg";
import IcMessage from "../../assets/images/svg/ic-message.svg";
import ContactModal from "./ContactModal";
const Socials = ({ initData }) => {
  const whatsapp = initData?.socials?.find((item) => item?.id === "GAE_Xt-HU");
  const phone = initData?.socials?.find((item) => item?.id === "vXyQHMYgU");
  const WhatsappIcon = `${process.env.NEXT_PUBLIC_MAIN_URL}${whatsapp?.socialType?.icon}`;
  const [isModalShow, setIsModalShow] = React.useState(false);
  const handleModalShow = () => {
    setIsModalShow(!isModalShow);
  };
  return (
    <div className="socials">
      <button
        href={whatsapp?.link}
        className="social"
        onClick={handleModalShow}
        aria-label="send mail icon"
      >
        <Image src={IcMessage} alt="" width={20} height={20} loading="lazy" />
      </button>
      <Link href={whatsapp?.link}>
        <a target="_blank" className="social" aria-label="send whasab message">
          <Image
            src={WhatsappIcon}
            alt="whatsab icon"
            width={20}
            height={20}
            loading="lazy"
          />
        </a>
      </Link>
      <Link href={`tel:${phone?.link}`}>
        <a
          target="_blank"
          className="social"
          aria-label="pthone to contact us "
        >
          <Image
            src={call.src}
            width={20}
            height={20}
            alt="phone icon"
            loading="lazy"
          />
        </a>
      </Link>
      <ContactModal show={isModalShow} onHide={handleModalShow} />
    </div>
  );
};

export default Socials;
